import { KYMW0902Model } from '../kymw0902.model';
import { DutiesDivPlanGoodsListModel } from '../vo/duties-div-plan-goods-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 業態別企画商品情報更新クラス
 *
 * @export UpdateDutiesDivPlanGoodsListService
 * @class UpdateDutiesDivPlanGoodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateDutiesDivPlanGoodsListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW0902Model = new KYMW0902Model;
  private vo: DutiesDivPlanGoodsListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateDutiesDivPlanGoodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        Rec: {
          condition: {
            OrderCode: this.vo.OrderCode
          },
          combination: this.vo.DutiesDivPlanGoodsVOList.map(dutiesDivPlanGoodsVO => {
            return {
              condition: {
                Pcode: dutiesDivPlanGoodsVO.Pcode,
                DutiesFormDailyDiv: dutiesDivPlanGoodsVO.DutiesFormDailyDiv,
                UpdateDate: dutiesDivPlanGoodsVO.UpdateDate,
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof UpdateDutiesDivPlanGoodsListService
   */
  execute(model: KYMW0902Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.send('KYMW09updateDutiesDivPlanGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateDutiesDivPlanGoodsListService
   */
  success(data: any): void {
    // 処理ログを表示させる
    this.model.kymw0902Component.updateResult(data);
    // 業態別企画商品一覧を最新の情報に更新
    this.model.kymw0902Component.reloadDutiesDivPlanGoodsList();
  }
}
